import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Role } from '../types/interfaces/role';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { TicketStatus } from '../types/interfaces/ticket-status';
import { ChatbotIntegration } from '../types/interfaces/chatbot/base';
import {
  NlpEntities,
  ChatbotIntentTemplateAttributes,
} from '../types/interfaces/chatbot/nlp';
import { IStepTypeMetadata } from '../pages/graph-editor/components/flow-sidebar/config-section/config-section.models';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private http = inject(HttpClient);

  getRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(`${environment.apiHost}/common/roles`, {
      withCredentials: true,
    });
  }

  getTicketStatuses(): Observable<TicketStatus[]> {
    return this.http.get<Role[]>(
      `${environment.apiHost}/common/ticket-statuses`,
      {
        withCredentials: true,
      },
    );
  }

  getChatbotStepTypes(): Observable<IStepTypeMetadata[]> {
    return this.http
      .get<IStepTypeMetadata[]>(
        `${environment.apiHost}/common/chatbot/step-types`,
        {
          withCredentials: true,
        },
      )
      .pipe(
        map((types) => {
          const menu = types.find((t) => t.type === 'menu');
          const optionsField = menu?.fields.find((f) => f.key === 'options');
          const childrenField = optionsField?.itemFields?.find(
            (f) => f.key === 'children',
          );

          if (
            childrenField &&
            (childrenField.itemFields as any) === '$ref:circular' &&
            optionsField
          ) {
            childrenField.itemFields = optionsField.itemFields; // Restore the link
          }
          return types;
        }),
      );
  }

  getChatbotIntegrations(): Observable<ChatbotIntegration[]> {
    return this.http.get<ChatbotIntegration[]>(
      `${environment.apiHost}/common/chatbot/integrations`,
      {
        withCredentials: true,
      },
    );
  }

  getNlpProviders() {
    return this.http.get<string[]>(
      `${environment.apiHost}/common/chatbot/nlp-providers`,
      {
        withCredentials: true,
      },
    );
  }

  getNlpEntities() {
    return this.http.get<NlpEntities[]>(
      `${environment.apiHost}/common/chatbot/nlp-entities`,
      {
        withCredentials: true,
      },
    );
  }

  getIntentTemplates() {
    return this.http.get<ChatbotIntentTemplateAttributes[]>(
      `${environment.apiHost}/intent-templates`,
      {
        withCredentials: true,
      },
    );
  }

  getIntentTemplate(id: number) {
    return this.http.get<ChatbotIntentTemplateAttributes>(
      `${environment.apiHost}/intent-templates/${id}`,
      {
        withCredentials: true,
      },
    );
  }

  getIntentTemplatesBulk(ids: number[]) {
    return this.http.post<ChatbotIntentTemplateAttributes[]>(
      `${environment.apiHost}/intent-templates/bulk`,
      ids,
      {
        withCredentials: true,
      },
    );
  }
}
